/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Check_SubtitleInputs */

const en_cv_check_subtitle = /** @type {(inputs: Cv_Check_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get AI-powered feedback on your resume`)
};

const de_cv_check_subtitle = /** @type {(inputs: Cv_Check_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erhalte KI-basiertes Feedback zu deinem Lebenslauf`)
};

/**
* | output |
* | --- |
* | "Get AI-powered feedback on your resume" |
*
* @param {Cv_Check_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cv_check_subtitle = /** @type {((inputs?: Cv_Check_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Check_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_check_subtitle(inputs)
	return en_cv_check_subtitle(inputs)
});